module.exports = __webpack_public_path__ + "img/zsy.1df5f2c1.jpg";